import React, { useRef, useState, useEffect } from "react";
import FontIcon from "react-md/lib/FontIcons";
import { Row, Col } from "react-flexbox-grid";
import "../styles/assignedServiceProvider.css";
import "../styles/assignChildServices.css";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import EventService from "../../../../../service/event/EventService";
import CreateServiceUtil from "../services/CreateServiceUtil";
import TextField from "react-md/lib/TextFields";
import { Button } from "react-md";
import { Modal } from "@material-ui/core";
import {
  ExpansionList,
  ExpansionPanel,
  SelectField,
  DialogContainer,
} from "react-md";
import ExpandableTable from "../helper/expandableTable";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import AssignServiceProviderUtil from "../services/AssignServiceProviderUtil";
import AvailabilityCalendar from "../helper/AvailabilityCalendar";
import CreateServiceProviderUtil from "../services/CreateServiceProviderUtil";
import CityTableAssignSP from "../helper/CityTableAssignSP";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "react-md-icon/dist/OutlineDelete";
import CloseIcon from "react-md-icon/dist/RoundClose";
import ServiceDashboardUtils from "../services/ServiceDashboardUtils";
import ExpandableTableAssignedChildServices from "../helper/expandableTableAssignedChildServices";

function AssignChildServices(props) {
  const [serviceData, setServiceData] = useState(null);
  const [pageNum, setPageNum] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [formData, setFormData] = useState({});
  const [stagedServices, setStagedServices] = useState(null);
  const [stagedForUpdateChildServices, setStagedForUpdateChildServices] =
    useState(null);

  const [assignedChildServicesResponse, setAssignedChildServicesResponse] =
    useState(null);
  // Column filters live in the table but are applied here, so that paging keeps
  // the filters and a filter change goes back to the first page.
  const [appliedFilters, setAppliedFilters] = useState({});
  const [errorObject, setErrorObject] = useState(null);
  const [allProvidersOfChildService, setAllProvidersOfChildService] =
    useState(null);

  // Child service waiting to be staged along with the provider modes of that
  // service which are still missing MRP/discounted price. Kept in state only
  // while the "Add price details" dialog is open.
  const [priceDialogData, setPriceDialogData] = useState(null);
  const [priceInputs, setPriceInputs] = useState({});
  const [savingPrices, setSavingPrices] = useState(false);

  const createServiceUtil = new CreateServiceUtil();
  const serviceDashboardUtils = new ServiceDashboardUtils();
  const assignServiceProviderUtil = new AssignServiceProviderUtil();

  const GROUPED_SERVICE_SERVICE_CATEGORY = 1;
  const CHILD_SERVICE_SERVICE_CATEGORY = 0;

  useEffect(() => {
    getServiceById(props.data.serviceId);
  }, []);

  useEffect(() => {
    if (serviceData?.id) {
      fetchAssignedChildServicesByFilter(
        serviceData?.id,
        pageNum,
        pageSize,
        appliedFilters,
        true,
      );
    }
  }, [serviceData?.id, pageNum, pageSize, appliedFilters]);

  const navigateToNextPage = () => {
    if (pageNum * pageSize < totalCount) {
      setPageNum((prevPageNum) => prevPageNum + 1);
    }
  };

  const navigateToPrevPage = () => {
    if (pageNum > 1) {
      setPageNum((prevPageNum) => prevPageNum - 1);
    }
  };

  const stringToInt = (str) => {
    const num = parseInt(str, 10); // Convert string to integer with base 10
    return isNaN(num) ? null : num; // Check if conversion failed
  };

  const getServiceById = (id) => {
    let onResponse = (res) => {
      setServiceData(res);
      updateFormDataField("service", "serviceTypeId", res?.serviceTypeId);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error while fetching service details: ${err?.message}`,
      });
    };
    createServiceUtil.getServiceById(id, onResponse, onError);
  };

  const exitPage = () => {
    props.setView(1);
  };

  const updateFormDataField = (parentKey, fieldKey, newValue) => {
    // setAssignedServiceProviderData({serviceProvider: {id: "176df7y"}})

    setFormData((prevData) => ({
      ...(prevData ?? {}),
      [parentKey]: {
        ...(prevData?.[parentKey] ?? {}),
        [fieldKey]: newValue,
      },
    }));
  };

  const assignChildServices = (groupServiceMappings) => {
    const onResponse = (res) => {
      console.log("ni- assignChildServices res=", res);
      // setAssignedChildServicesResponse(res);
      if ((res?.errorCount ?? 0) > 0) {
        setErrorObject((prev) => res);
        EventService.emit("showError", {
          message: `Child services saved partially with ${
            res?.errorCount ?? 0
          } errors`,
        });
        let newStagedServices = [];
        (res?.responses ?? []).forEach((e) => {
          if (Boolean(e?.error ?? "")) {
            const serviceDetails = (stagedServices ?? []).find(
              (s) => s?.id === e?.childServiceId,
            );
            if (serviceDetails) {
              newStagedServices.push(serviceDetails);
            }
          }
        });
        setStagedServices(newStagedServices);

        let newStagedForUpdateChildServices = [];
        (res?.responses ?? []).forEach((e) => {
          if (Boolean(e?.error ?? "")) {
            const serviceDetails = (stagedForUpdateChildServices ?? []).find(
              (s) => s?.id === e?.childServiceId,
            );
            if (serviceDetails) {
              newStagedForUpdateChildServices.push(serviceDetails);
            }
          }
        });

        setStagedForUpdateChildServices(newStagedForUpdateChildServices);
      } else {
        setErrorObject(null);
        EventService.emit("showError", {
          message: `Child services saved successfully`,
        });
        setStagedServices(null);
        setStagedForUpdateChildServices(null);
      }
      setFormData((prev) => {});
      fetchAssignedChildServicesByFilter(
        serviceData?.id,
        pageNum,
        pageSize,
        appliedFilters,
        true,
      );
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in saving assigned child services: ${err?.message}`,
      });
    };
    serviceDashboardUtils.assignChildServices(
      groupServiceMappings ?? {},
      onResponse,
      onError,
    );
  };

  const fetchAssignedChildServicesByFilter = (
    groupServiceId,
    pageNum,
    pageSize,
    filtersObj,
    includeProviderDetails,
    isActive = true,
  ) => {
    const onResponse = (res) => {
      console.log("ni- fetchAssignedChildServicesByFilter res=", res);
      setAssignedChildServicesResponse(res);
      setTotalCount(res?.totalCount);
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching assigned child services: ${err?.message}`,
      });
    };
    serviceDashboardUtils.fetchAssignedChildServicesByFilter(
      {
        pageNum: pageNum,
        pageSize: pageSize,
        groupServiceId: groupServiceId,
        isActive: isActive,
        ...(filtersObj ?? {}),
        includeProviderDetails: includeProviderDetails ?? false,
      },
      onResponse,
      onError,
    );
  };

  const getServiceWithChildMapping = (
    idNum,
    serviceTypeId,
    serviceCode,
    serviceCategory,
  ) => {
    const onResponse = (res) => {
      console.log("ni- getServiceWithChildMapping res=", res);
      if (res?.services?.[0]) {
        setFormData((prev) => ({ ...prev, service: res?.services?.[0] }));
      } else {
        EventService.emit("showError", {
          message: `No child service matched with the provided details.`,
        });
      }
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching service details: ${err?.message}`,
      });
    };
    serviceDashboardUtils.getServiceWithChildMapping(
      idNum
        ? {
            Ids: [stringToInt(idNum)],
            groupServiceId: serviceData?.id,
            serviceTypeIds: [serviceTypeId],
            serviceCategory: serviceCategory,
          }
        : {
            nameMatch: [serviceCode?.toString()],
            groupServiceId: serviceData?.id,
            serviceTypeIds: [serviceTypeId],
            serviceCategory: serviceCategory,
          },
      onResponse,
      onError,
    );
  };

  const getServiceDetailsSection = () => {
    return (
      <div className="service-details-container">
        <Row>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service ID`}</div>
              <div>
                <TextField
                  id="serviceId"
                  name="serviceId"
                  type="text"
                  // leftIcon={<FontIcon>assignment</FontIcon>}
                  disabled
                  value={serviceData?.id}
                  // error={ this.state.error.description ? true : false }
                  // errorText={ this.state.error.description }
                  // onChange={ this._syncState }
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service`}</div>
              <div>
                <TextField
                  id="service"
                  name="service"
                  type="text"
                  disabled
                  value={serviceData?.name}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service name`}</div>
              <div>
                <TextField
                  id="serviceName"
                  name="serviceName"
                  type="text"
                  disabled
                  value={serviceData?.serviceName}
                />
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={5} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service type`}</div>
              <div>
                <TextField
                  id="serviceType"
                  name="serviceType"
                  type="text"
                  disabled
                  value={serviceData?.serviceTypeName}
                />
              </div>
            </div>
          </Col>
          {serviceData?.serviceSubtypeId !== 0 && (
            <Col xs={12} sm={5} md={4} lg={4}>
              <div className="mp-field-container">
                <div className="mp-label">{`Service subtype`}</div>
                <div>
                  <TextField
                    id="serviceSubtype"
                    name="serviceSubtype"
                    type="text"
                    disabled
                    value={serviceData?.serviceSubtypeName}
                  />
                </div>
              </div>
            </Col>
          )}
        </Row>
      </div>
    );
  };

  const isServiceValidForConfirm = () => {
    let errorOccurred = false;
    if (formData?.service) {
      const serviceRequiredFields = [
        "serviceTypeId",
        "id",
        "name",
        // "serviceSubtypeName",
        "serviceName",
      ];
      serviceRequiredFields.forEach((e) => {
        if (errorOccurred) return;
        if (formData?.service?.[e]) {
        } else {
          errorOccurred = true;
          EventService.emit("showError", {
            message: `${e} is required in service details`,
          });
        }
      });

      // checking if this service is already staged for assigning as a child service
      if (
        (stagedServices ?? []).some(
          (e) => (e?.id ?? -1) === (formData?.service?.id ?? -2),
        )
      ) {
        errorOccurred = true;
        EventService.emit("showError", {
          message: `(${formData?.service?.id}) ${formData?.service?.serviceName} -  is already selected for assignment as a child service`,
        });
      }
    } else {
      EventService.emit("showError", {
        message: "Please enter service details",
      });
      errorOccurred = false;
      return false;
    }

    if (errorOccurred) {
      return false;
    }

    return true;
  };

  const stageChildService = (service) => {
    setStagedServices((prev) => [...(prev ?? []), service]);
    setFormData((prev) => {});
  };

  const isPriceMissing = (value) =>
    value === null ||
    value === undefined ||
    value.toString().trim() === "" ||
    Number(value) === 0;

  // A child service can be sold only if every enabled mode of every provider
  // assigned to it carries an MRP and a discounted price. Collect the modes
  // which are still missing either of them so that they can be filled in from
  // the "Add price details" dialog.
  const getModesMissingPrices = (assignedServiceProviders, serviceById) => {
    const rows = [];
    (assignedServiceProviders ?? []).forEach((assignment) => {
      (assignment?.serviceModes ?? []).forEach((serviceMode, modeIdx) => {
        if (!serviceMode?.enabled) return;
        if (
          isPriceMissing(serviceMode?.maxRetailPrice) ||
          isPriceMissing(serviceMode?.discountedPrice)
        ) {
          rows.push({
            key: `${assignment?.id}-${modeIdx}`,
            assignment: assignment,
            modeIdx: modeIdx,
            serviceMode: serviceMode,
            service: serviceById?.[assignment?.serviceId] ?? null,
          });
        }
      });
    });
    return rows;
  };

  // Opens the price dialog for the modes which are missing prices. onComplete
  // is what the dialog was opened for - staging the service or saving the
  // screen - and runs once every price has been written.
  const openPriceDialogForServices = (serviceById, onComplete, onNothing) => {
    const serviceIds = Object.keys(serviceById ?? {})
      .map((id) => stringToInt(id))
      .filter((id) => id !== null);
    // An empty serviceIds filter would fetch every assignment in the system,
    // so never send the request without at least one resolved service id.
    if (serviceIds.length === 0) {
      EventService.emit("showError", {
        message: `Unable to read the service id of the child service(s)`,
      });
      return;
    }
    const onResponse = (res) => {
      const rows = getModesMissingPrices(
        res?.assignedServiceProviders ?? [],
        serviceById,
      );
      if (rows.length === 0) {
        onNothing();
        return;
      }
      // Prefill whichever of the two prices is already present.
      let inputs = {};
      rows.forEach((row) => {
        inputs[row.key] = {
          maxRetailPrice: isPriceMissing(row?.serviceMode?.maxRetailPrice)
            ? ""
            : row?.serviceMode?.maxRetailPrice,
          discountedPrice: isPriceMissing(row?.serviceMode?.discountedPrice)
            ? ""
            : row?.serviceMode?.discountedPrice,
        };
      });
      setPriceInputs(inputs);
      setPriceDialogData({ rows: rows, onComplete: onComplete });
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching assigned service providers of the child service(s): ${err?.message}`,
      });
    };
    assignServiceProviderUtil.getAssignedServiceProvidersByFilter(
      { serviceIds: serviceIds },
      onResponse,
      onError,
    );
  };

  const addChildServiceAfterPriceCheck = (service) => {
    if (stringToInt(service?.id) === null) {
      EventService.emit("showError", {
        message: `Unable to read the service id of the selected child service`,
      });
      return;
    }
    openPriceDialogForServices(
      { [service?.id]: service },
      () => {
        stageChildService(service);
        // The child services table below carries the provider prices, so pull
        // it again to show what was just written.
        fetchAssignedChildServicesByFilter(
          serviceData?.id,
          pageNum,
          pageSize,
          appliedFilters,
          true,
        );
      },
      () => stageChildService(service),
    );
  };

  // A mode can be added to a provider long after the child service was mapped
  // to this group, so the prices of everything that stays mapped are checked
  // again on save - not just of the services staged in this session.
  const saveChildServicesAfterPriceCheck = (groupServiceMappings) => {
    const stagedForDeleteIds = new Set(
      (stagedForUpdateChildServices ?? []).map((e) => e?.id),
    );
    const onResponse = (res) => {
      let serviceById = {};
      (res?.services ?? []).forEach((service) => {
        if (service?.id && !stagedForDeleteIds.has(service?.id)) {
          serviceById[service.id] = service;
        }
      });
      (stagedServices ?? []).forEach((service) => {
        if (service?.id) {
          serviceById[service.id] = service;
        }
      });
      if (Object.keys(serviceById).length === 0) {
        assignChildServices({ groupServiceMappings });
        return;
      }
      openPriceDialogForServices(
        serviceById,
        () => assignChildServices({ groupServiceMappings }),
        () => assignChildServices({ groupServiceMappings }),
      );
    };
    const onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching assigned child services: ${err?.message}`,
      });
    };
    // Page number and size of 0 fetch every mapped child service instead of
    // only the page currently shown in the table.
    serviceDashboardUtils.fetchAssignedChildServicesByFilter(
      {
        pageNum: 0,
        pageSize: 0,
        groupServiceId: serviceData?.id,
        isActive: true,
      },
      onResponse,
      onError,
    );
  };

  const closePriceDialog = () => {
    setPriceDialogData(null);
    setPriceInputs({});
  };

  const updatePriceInput = (rowKey, fieldKey, newValue) => {
    setPriceInputs((prevData) => ({
      ...(prevData ?? {}),
      [rowKey]: {
        ...(prevData?.[rowKey] ?? {}),
        [fieldKey]: newValue,
      },
    }));
  };

  const getProviderModeLabel = (row) =>
    `${row?.serviceMode?.mode} mode of (${row?.assignment?.serviceProviderId})${
      row?.assignment?.serviceProviderName
    } for the child service ${row?.service?.serviceName ?? row?.assignment?.serviceId}`;

  const arePriceInputsValid = () => {
    let errorOccurred = false;
    (priceDialogData?.rows ?? []).forEach((row) => {
      if (errorOccurred) return;
      const maxRetailPrice = Number(priceInputs?.[row.key]?.maxRetailPrice);
      const discountedPrice = Number(priceInputs?.[row.key]?.discountedPrice);

      if (
        isPriceMissing(priceInputs?.[row.key]?.maxRetailPrice) ||
        isNaN(maxRetailPrice) ||
        maxRetailPrice <= 0
      ) {
        EventService.emit("showError", {
          message: `MRP is required in ${getProviderModeLabel(row)}`,
        });
        errorOccurred = true;
        return;
      }
      if (
        isPriceMissing(priceInputs?.[row.key]?.discountedPrice) ||
        isNaN(discountedPrice) ||
        discountedPrice <= 0
      ) {
        EventService.emit("showError", {
          message: `Discounted price is required in ${getProviderModeLabel(
            row,
          )}`,
        });
        errorOccurred = true;
        return;
      }
      // Same rule the service provider assignment API enforces.
      if (discountedPrice >= maxRetailPrice) {
        EventService.emit("showError", {
          message: `Discounted price should be less than the MRP in ${getProviderModeLabel(
            row,
          )}`,
        });
        errorOccurred = true;
      }
    });
    return !errorOccurred;
  };

  const savePriceDetails = () => {
    if (savingPrices || !arePriceInputsValid()) {
      return;
    }

    // The assignment API replaces the whole document, so every edited mode of a
    // provider goes out in a single update for that provider.
    let assignmentsById = {};
    (priceDialogData?.rows ?? []).forEach((row) => {
      const assignmentId = row?.assignment?.id;
      const assignment = assignmentsById[assignmentId] ?? {
        ...(row?.assignment ?? {}),
        serviceModes: [...(row?.assignment?.serviceModes ?? [])],
      };
      assignment.serviceModes[row.modeIdx] = {
        ...(assignment.serviceModes[row.modeIdx] ?? {}),
        maxRetailPrice: Number(priceInputs?.[row.key]?.maxRetailPrice),
        discountedPrice: Number(priceInputs?.[row.key]?.discountedPrice),
      };
      assignmentsById[assignmentId] = assignment;
    });

    const updates = Object.values(assignmentsById).map((assignment) => ({
      id: assignment?.id,
      body: {
        serviceId: assignment?.serviceId,
        serviceProviderId: assignment?.serviceProviderId,
        isActive: assignment?.isActive,
        externalServiceId: assignment?.externalServiceId,
        externalServiceName: assignment?.externalServiceName,
        externalServiceDescription: assignment?.externalServiceDescription,
        serviceModes: assignment?.serviceModes,
      },
    }));

    setSavingPrices(true);
    // Saved one provider after the other so that a failure can be reported
    // against the provider it belongs to. Providers saved before the failure
    // stay saved and saving again is harmless.
    const saveNext = (idx) => {
      if (idx >= updates.length) {
        setSavingPrices(false);
        EventService.emit("showError", {
          message: `Price details saved successfully`,
        });
        const onComplete = priceDialogData?.onComplete;
        closePriceDialog();
        if (onComplete) {
          onComplete();
        }
        return;
      }
      assignServiceProviderUtil.updateAssignedServiceProvider(
        updates[idx].id,
        updates[idx].body,
        () => saveNext(idx + 1),
        (err) => {
          setSavingPrices(false);
          EventService.emit("showError", {
            message: `Error in saving price details: ${err?.message}`,
          });
        },
      );
    };
    saveNext(0);
  };

  const getPriceDetailRow = (row) => {
    return (
      <div className="acs-price-dialog-row" key={row?.key}>
        <Row>
          <Col xs={12} sm={4} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service ID`}</div>
              <div className="acs-price-dialog-value">
                {row?.service?.id ?? row?.assignment?.serviceId ?? "-"}
              </div>
            </div>
          </Col>
          <Col xs={12} sm={4} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service code`}</div>
              <div className="acs-price-dialog-value">
                {row?.service?.name ?? "-"}
              </div>
            </div>
          </Col>
          <Col xs={12} sm={4} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service name`}</div>
              <div className="acs-price-dialog-value">
                {row?.service?.serviceName ?? "-"}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={4} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service mode`}</div>
              <div className="acs-price-dialog-value">
                {row?.serviceMode?.mode ?? "-"}
              </div>
            </div>
          </Col>
          <Col xs={12} sm={4} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Service provider`}</div>
              <div className="acs-price-dialog-value">
                {`(${row?.assignment?.serviceProviderId ?? "-"})${
                  row?.assignment?.serviceProviderName ?? "-"
                }${
                  row?.assignment?.serviceProviderCity
                    ? ` , ${row?.assignment?.serviceProviderCity}`
                    : ""
                }`}
              </div>
            </div>
          </Col>
          <Col xs={12} sm={4} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">{`Cost price`}</div>
              <div className="acs-price-dialog-value">
                {row?.serviceMode?.price ?? "-"}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={4} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">
                {`MRP`}
                <label className="account-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  id={`maxRetailPrice-${row?.key}`}
                  name="maxRetailPrice"
                  type="number"
                  placeholder="Type here"
                  lineDirection="left"
                  disabled={savingPrices}
                  value={priceInputs?.[row?.key]?.maxRetailPrice ?? ""}
                  onChange={(value) =>
                    updatePriceInput(row?.key, "maxRetailPrice", value)
                  }
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={4} md={4} lg={4}>
            <div className="mp-field-container">
              <div className="mp-label">
                {`Discounted price`}
                <label className="account-module-label-red"> *</label>
              </div>
              <div>
                <TextField
                  id={`discountedPrice-${row?.key}`}
                  name="discountedPrice"
                  type="number"
                  placeholder="Type here"
                  lineDirection="left"
                  disabled={savingPrices}
                  value={priceInputs?.[row?.key]?.discountedPrice ?? ""}
                  onChange={(value) =>
                    updatePriceInput(row?.key, "discountedPrice", value)
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  const getStageServiceItem = (stagedService, idx) => {
    return (
      <div className="acs-staged-service-item">
        <div>{stagedService?.serviceName ?? ""}</div>
        <IconButton
          onClick={(e) => {
            const newStagedServices = (stagedServices ?? []).toSpliced(idx, 1);
            setStagedServices((prev) => newStagedServices ?? []);
          }}
          className="navigo-appoint-section-6-grid-edit-call"
        >
          <DeleteIcon
            style={{
              // fontSize: "10em",
              color: "orange",
            }}
          />
        </IconButton>
      </div>
    );
  };

  const getStageServiceForUpdateItem = (stagedService, idx) => {
    return (
      <div className="acs-staged-service-item">
        <div>{stagedService?.serviceName ?? ""}</div>
        <IconButton
          onClick={(e) => {
            const newStagedServices = (stagedServices ?? []).toSpliced(idx, 1);
            setStagedForUpdateChildServices((prev) => newStagedServices ?? []);
          }}
          className="navigo-appoint-section-6-grid-edit-call"
        >
          <CloseIcon
            style={{
              // fontSize: "10em",
              color: "orange",
            }}
          />
        </IconButton>
      </div>
    );
  };

  return (
    <div className="outermost-div">
      <div className="heading-outer-container">
        <div className="heading-inner-container">
          <div
            className="heading-back-arrow"
            onClick={() => {
              exitPage();
            }}
          >
            <FontIcon style={{ fontSize: "36px", marginTop: "-7px" }}>
              arrow_back
            </FontIcon>
          </div>
          <div className="heading-inner-container-text-and-btns">
            <h1 className="heading-text">{`Assign child services`}</h1>

            <div style={{ display: "flex", flexDirection: "row" }}>
              <Button
                raised
                secondary
                style={{
                  textTransform: "none",
                }}
                disabled={
                  !(
                    (stagedServices ?? []).length > 0 ||
                    (stagedForUpdateChildServices ?? []).length > 0
                  )
                }
                onClick={() => {
                  const groupServiceMappings = [
                    ...(stagedServices ?? []).map((ele) => ({
                      groupServiceId: serviceData?.id,
                      childServiceId: ele?.id,
                      id: ele?.childServiceMappingId,
                      isActive: true,
                    })),

                    ...(stagedForUpdateChildServices ?? []).map((ele) => ({
                      groupServiceId: serviceData?.id,
                      childServiceId: ele?.id,
                      id: ele?.childServiceMappingId,
                      isActive: false,
                    })),
                  ];

                  // Nothing pending to add or delete: skip the empty API call
                  // (an empty groupServiceMappings payload is rejected by the
                  // backend). Use Cancel to leave the screen.
                  if (groupServiceMappings.length === 0) {
                    return;
                  }

                  saveChildServicesAfterPriceCheck(groupServiceMappings);
                }}
              >
                Save
              </Button>
              <div style={{ width: "15px" }}></div>
              <Button
                raised
                style={{
                  color: "#333333",
                  backgroundColor: "#EBEBEB",
                  textTransform: "none",
                }}
                onClick={() => {
                  exitPage();
                }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "40px" }}></div>
      {getServiceDetailsSection()}
      <div style={{ height: "25px" }}></div>

      <div className="service-details-container">
        <div className="acs-add-service-section">
          <h3>Add new service</h3>

          <div className="mp-plan-create-service-container">
            <Row>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-field-container">
                  <div className="mp-label">{`Service type`}</div>
                  <div>
                    <TextField
                      id="serviceType"
                      name="serviceType"
                      type="text"
                      disabled
                      value={serviceData?.serviceTypeName}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div style={{ height: "20px" }}></div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">
                    {`Service ID`}
                    <label className="account-module-label-red"> *</label>
                  </div>
                  <div>
                    <TextField
                      type="text"
                      value={formData?.service?.id ?? ""}
                      placeholder="Type here"
                      onChange={(e) => {
                        setFormData(() => {});
                        updateFormDataField("service", "id", e);
                        updateFormDataField(
                          "service",
                          "serviceTypeId",
                          serviceData?.serviceTypeId,
                        );
                      }}
                      lineDirection="left"
                      inlineIndicator={
                        <Button
                          icon
                          className="text-fields__inline-btn"
                          disabled={!formData?.service?.id}
                          style={{
                            margin: "-10px",
                          }}
                        >
                          <FontIcon
                            style={{
                              color: "orange",
                              lineHeight: "0",
                              marginBottom: "15px",
                            }}
                            onClick={() => {
                              // check if this service provider is already assigned to this service And proceed
                              getServiceWithChildMapping(
                                formData?.service?.id,
                                formData?.service?.serviceTypeId,
                                null,
                                CHILD_SERVICE_SERVICE_CATEGORY,
                              );
                            }}
                          >
                            arrow_forward
                          </FontIcon>
                        </Button>
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={1} md={1} lg={1}>
                <div className="mp-astp-or-text">OR</div>
              </Col>
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">
                    {`Service code`}
                    <label className="account-module-label-red"> *</label>
                  </div>
                  <div>
                    <TextField
                      type="text"
                      value={formData?.service?.name ?? ""}
                      placeholder="Type here"
                      onChange={(e) => {
                        setFormData(() => {});
                        updateFormDataField("service", "name", e);
                        updateFormDataField(
                          "service",
                          "serviceTypeId",
                          serviceData?.serviceTypeId,
                        );
                      }}
                      lineDirection="left"
                      inlineIndicator={
                        <Button
                          icon
                          className="text-fields__inline-btn"
                          // disabled={!formData?.service?.serviceIdNum}
                          style={{
                            margin: "-10px",
                          }}
                          disabled={!formData?.service?.name}
                        >
                          <FontIcon
                            style={{
                              color: "orange",
                              lineHeight: "0",
                              marginBottom: "15px",
                            }}
                            onClick={() => {
                              // check if this service provider is already assigned to this service And proceed
                              getServiceWithChildMapping(
                                null,
                                formData?.service?.serviceTypeId,
                                formData?.service?.name,
                                CHILD_SERVICE_SERVICE_CATEGORY,
                              );
                            }}
                          >
                            arrow_forward
                          </FontIcon>
                        </Button>
                      }
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <br />
            <Row>
              {formData?.service?.serviceSubtypeId !== 0 && (
                <>
                  <Col xs={12} sm={3} md={3} lg={3}>
                    <div className="mp-plan-create-service-field-container">
                      <div className="mp-plan-label">{`Service sub type`}</div>
                      <div>
                        <TextField
                          value={formData?.service?.serviceSubtypeName ?? ""}
                          lineDirection="left"
                          disabled
                          placeholder="Sub type"
                        />
                      </div>
                    </div>
                  </Col>

                  <Col xs={12} sm={1} md={1} lg={1}>
                    <div style={{ height: "20px" }}></div>
                  </Col>
                </>
              )}
              <Col xs={12} sm={3} md={3} lg={3}>
                <div className="mp-plan-create-service-field-container">
                  <div className="mp-plan-label">{`Service name`}</div>
                  <div>
                    <TextField
                      value={formData?.service?.serviceName ?? ""}
                      lineDirection="left"
                      disabled
                      placeholder="Name"
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Button
                style={{
                  marginLeft: "8px",
                  marginTop: "18px",
                  textTransform: "none",
                }}
                raised
                secondary
                disabled={!formData?.service?.serviceName}
                onClick={() => {
                  if (isServiceValidForConfirm()) {
                    // Missing MRP/discounted price on any enabled provider mode
                    // has to be filled in before the service can be staged.
                    addChildServiceAfterPriceCheck(formData?.service);
                  }
                }}
              >
                Add
              </Button>
            </Row>
          </div>
        </div>

        {Boolean((stagedServices ?? []).length > 0) && (
          <div className="acs-add-service-section">
            <div style={{ height: "24px" }}></div>
            <h4>Child services to be added</h4>

            <div className="acs-staged-services-outer-div">
              {(stagedServices ?? []).map((stagedService, idx) =>
                getStageServiceItem(stagedService, idx),
              )}
            </div>
          </div>
        )}

        {Boolean((stagedForUpdateChildServices ?? []).length > 0) && (
          <div className="acs-add-service-section">
            <div style={{ height: "24px" }}></div>
            <h4>Child services to be deleted</h4>

            <div className="acs-staged-services-outer-div">
              {(stagedForUpdateChildServices ?? []).map((stagedService, idx) =>
                getStageServiceForUpdateItem(stagedService, idx),
              )}
            </div>
          </div>
        )}

        <div style={{ height: "32px" }}></div>

        <div className="acs-add-service-section">
          <h4>Child services</h4>

          <ExpandableTableAssignedChildServices
            assignedChildServices={
              assignedChildServicesResponse?.services ?? []
            }
            providerMap={assignedChildServicesResponse?.providerMap ?? []}
            provdersLimit={2}
            pageNum={pageNum}
            pageSize={pageSize}
            totalCount={totalCount}
            goToPrevPage={navigateToPrevPage}
            goToNextPage={navigateToNextPage}
            stagedForUpdateChildServices={stagedForUpdateChildServices}
            setAllProvidersOfChildService={setAllProvidersOfChildService}
            fetchAssignedChildServicesByFilter={(filtersObj) => {
              // The table reports its filters on mount too, so only a real
              // change is applied - otherwise this would refetch the first
              // page over whatever page is being shown.
              setAppliedFilters((prev) =>
                JSON.stringify(prev ?? {}) === JSON.stringify(filtersObj ?? {})
                  ? prev
                  : filtersObj ?? {},
              );
              setPageNum(1);
            }}
            handleDeleteAssignedChildService={(service) => {
              console.log(
                "ni- handleDeleteAssignedChildService service=",
                service,
              );
              if (service?.id) {
                setStagedForUpdateChildServices((prev) => [
                  ...(prev ?? []),
                  service,
                ]);
              }
            }}
          />
        </div>

        {Boolean(errorObject) && (
          <div className="modal-overlay">
            <div className="modal error-modal">
              <h3>Error in saving child services</h3>
              <div
                className="error-modal-content"
                style={{ textAlign: "left" }}
              >
                <p>
                  {(errorObject?.totalCount ?? 0) -
                    (errorObject?.errorCount ?? 0)}{" "}
                  out of {errorObject?.totalCount ?? 0} child service(s) have
                  been saved successfully but there are some errors in saving{" "}
                  {errorObject?.errorCount ?? 0} child service(s), please
                  rectify and try again
                </p>

                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    textAlign: "left",
                    paddingRight: "10px",
                  }}
                >
                  {(errorObject?.responses ?? [])
                    .filter((ele) => Boolean(ele?.error ?? ""))
                    .map((e, index) => (
                      <div key={index} style={{ marginBottom: "10px" }}>
                        <strong>Child service Id:</strong>{" "}
                        {e?.childServiceId ?? "-"} <br />
                        <strong>Error:</strong> {e?.error ?? "-"}
                      </div>
                    ))}
                </div>
              </div>

              <div style={{ height: "32px" }}></div>
              <Button
                raised
                className={"mp-button-save-enabled"}
                onClick={() => setErrorObject(null)}
              >
                {"Okay"}
              </Button>
              <div style={{ height: "32px" }}></div>
            </div>
          </div>
        )}

        {Boolean(priceDialogData) && (
          <Modal open={true} onClose={() => {}} disableBackdropClick={true}>
            <div
              style={{ width: "60%", left: "30%" }}
              className="custom-modal-content scrollable-modal-full-height"
            >
              <div className="acs-price-dialog-header">
                <div className="acs-price-dialog-title">
                  {"Add price details"}
                </div>
                <IconButton
                  disabled={savingPrices}
                  onClick={() => closePriceDialog()}
                >
                  <CloseIcon fontSize="large" />
                </IconButton>
              </div>

              <div className="acs-price-dialog-banner">
                {"MRP and Discounted price is mandatory for individual test"}
              </div>

              {(priceDialogData?.rows ?? []).map((row) =>
                getPriceDetailRow(row),
              )}

              <div className="acs-price-dialog-actions">
                <Button
                  raised
                  secondary
                  style={{ textTransform: "none" }}
                  disabled={savingPrices}
                  onClick={() => savePriceDetails()}
                >
                  Save
                </Button>
                <div style={{ width: "15px" }}></div>
                <Button
                  raised
                  style={{
                    color: "#333333",
                    backgroundColor: "#EBEBEB",
                    textTransform: "none",
                  }}
                  disabled={savingPrices}
                  onClick={() => closePriceDialog()}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Modal>
        )}

        {Boolean(allProvidersOfChildService) && (
          <Modal open={true} onClose={() => {}} disableBackdropClick={true}>
            <div
              style={{ width: "90%", left: "45%" }}
              className="custom-modal-content scrollable-modal-full-height"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    fontSize: "24px",
                    fontWeight: 700,
                    fontFamily: "Montserrat",
                    textAlign: "center",
                  }}
                >
                  {"(" +
                    allProvidersOfChildService?.assignedChildServices?.[0]?.id +
                    ") " +
                    allProvidersOfChildService?.assignedChildServices?.[0]
                      ?.serviceName}
                </div>

                <IconButton onClick={() => setAllProvidersOfChildService(null)}>
                  <CloseIcon fontSize="large" />
                </IconButton>
              </div>

              <div style={{ height: "32px" }}></div>

              <div style={{ textAlign: "left" }}>
                <ExpandableTableAssignedChildServices
                  assignedChildServices={
                    allProvidersOfChildService?.assignedChildServices ?? []
                  }
                  providerMap={allProvidersOfChildService?.providerMap ?? []}
                  fetchAssignedChildServicesOnInit={false}
                  mode={"view"}
                  showPagination={false}
                  showSeeAll={false}
                  pageNum={pageNum}
                  pageSize={pageSize}
                  totalCount={totalCount}
                  stagedForUpdateChildServices={stagedForUpdateChildServices}
                  setAllProvidersOfChildService={setAllProvidersOfChildService}
                  fetchAssignedChildServicesByFilter={(filtersObj) => {}}
                  handleDeleteAssignedChildService={(service) => {}}
                />
              </div>
              <div style={{ height: "32px" }}></div>
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
}

export default AssignChildServices;
